/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AppContextType } from '../store/AppContext';
import {
  BlockHello,
  BlockLink,
  BlockLinkBrand,
  BlockLinkSameTarget,
  DropdownLink,
  IconLinkBlock,
  MainmenuLink,
} from './bricks';

import {
  IconArrowDown,
  IconArrowPrev,
  IconChat,
  IconContacto,
  IconHome,
  IconMenu,
  IconSalir,
  IconSuperonline,
  IconTiendas,
  IconX,
} from '../Icons';
import { AccessType, configAccessType } from '../types/Types';
import IconChef from '../Icons/IconChef';
import IconHeartMatrona from '../Icons/IconHeart';
import IconCapraboClub from '../Icons/IconCapraboClub';
import { StorageHelper } from '../utils/StorageHelper';
import IconCapraboClubMenuMovile from '../Icons/IconCapraboClubMenuMovile';
import ModalConfirmacion from './ModalConfirmacion';
import DataService from '../services/MisDatosService';
import { ErrorCodeConstants } from '../utils/ErrorCodeConstants';
import { FooterConstants } from '../utils/FooterConstants';
import routerLoader from '../i18n/router';
import { useMisDatosStore } from '../pages/MisDatos/context/MisDatos.context';

interface Props {
  setMenuMobile: any;
  menuMobile: boolean;
  clickLogo: any;
  languaje: string;
  setLanguajeHadler: any;
  userName: string;
  miCuenta: AccessType[];
  ventajas: AccessType[];
  getUrl: any;
  isUrlActive: any;
  setShowMiCuenta: any;
  isUrlActiveMiCuenta: any;
  clickMiCuenta: any;
  miCuentaText: string;
  showMiCuenta: boolean;
  isClicked: boolean;
  setIsClicked: any;
  solicitarTarjeta: AccessType | undefined;
  access: configAccessType;
  APP_BASE_URL: string | undefined;
  dataApp: AppContextType;
}
const HeaderCaprabo: FC<Props> = (props) => {
  const {
    setMenuMobile,
    menuMobile,
    clickLogo,
    languaje,
    setLanguajeHadler,
    userName,
    miCuenta,
    ventajas,
    getUrl,
    isUrlActive,
    setShowMiCuenta,
    isUrlActiveMiCuenta,
    clickMiCuenta,
    miCuentaText,
    showMiCuenta,
    isClicked,
    setIsClicked,
    solicitarTarjeta,
    access,
    APP_BASE_URL,
    dataApp,
  } = props;
  const { t } = useTranslation();
  const { lang, handleModalDatosPersonales } = dataApp;
  const [showError, setShowError] = useState(false);
  const [showDniError, setShowDniError] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [typeError, setTypeError] = useState<number>();
  const location = useLocation();
  const { showModalContactEmail, hideModalV2P } = useMisDatosStore();
  const getHTMLContent = () => {
    return `${t(
      'tarjetas.tarjeta-socio.error-AME-sac-prevalidation-message',
    )} <a href="tel:932616060" style="color: #4a90e2; text-decoration: none;">${
      FooterConstants.TELEFONO_ATENCION_CLIENTE_CAPRABO
    }.</a>`;
  };

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    DataService.checkPrevalidacionDatosAltaClub()
      .then((responsePrevalidacion) => {
        if (responsePrevalidacion.data.error) {
          setMessageError(
            t('tarjetas.tarjeta-socio.error-AME-prevalidation-message-caprabo'),
          );

          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
          ) {
            setShowError(true);
            setTypeError(
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION,
            );
          }
          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
          ) {
            setShowError(true);
            setTypeError(
              ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION,
            );
          }
          if (
            responsePrevalidacion.data.errorCode ===
            ErrorCodeConstants.UPDATE_DATOSACCESO_CLIENTEV0_DNI_NO_EDITABLE_SAC
          ) {
            setShowDniError(true);
          }
        } else {
          StorageHelper.deleteUserFromSessionAndRedirect(
            access.solicitarTarjeta,
            lang,
            APP_BASE_URL,
            e,
            '',
          );
        }
      })
      .catch((er: any) => {
        console.log(er);
        setMessageError(t('nlr-vaya-algo-no-ha-ido-bien'));
        setShowError(true);
      });
  };

  const goToMisDatosAndOpenModal = () => {
    if (location.pathname.includes('mis-datos')) {
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
      ) {
        const formDireccion = document.querySelector(
          '[id^="habitual-"]',
        ) as HTMLFormElement;
        if (formDireccion) {
          formDireccion.classList.add('visible');
          const submitButtons = document.querySelectorAll(
            '[id^="direccion-submit-btn-"]',
          );
          const button = submitButtons[0] as HTMLElement;
          button.click();
        }
      } else if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
      ) {
        StorageHelper.setOpenAltaClubPersonalData();
        handleModalDatosPersonales(true);
      }
    } else {
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
      ) {
        StorageHelper.setOpenV2PFromOro();
        StorageHelper.setOpenDireccionHabitual();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
      ) {
        StorageHelper.setOpenV2PFromOro();
        StorageHelper.setOpenOroPersonalData();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
      ) {
        StorageHelper.setOpenV2PFromOro();
        StorageHelper.setOpenOroPersonalData();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
      ) {
        StorageHelper.setOpenTelefonoError();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
      ) {
        showModalContactEmail();
      }
      hideModalV2P();
      window.location.href = routerLoader.LoadRouterByPath(
        'mis-datos',
        dataApp.lang,
      );
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {
    StorageHelper.removeOpenAltaClubPersonalData();
    handleModalDatosPersonales(false);
  };

  useEffect(() => {
    if (
      !menuMobile &&
      document.body.classList.contains('fix') &&
      window.innerWidth <= 990
    )
      document.body.classList.remove('fix');
  }, [menuMobile]);

  return (
    <header className="header">
      <div className="menu-top">
        <div className="main-menu__mobile">
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            className="icon icon-large menu-buttom"
            onKeyDown={() => null}
            onClick={() => {
              console.log(menuMobile);
              setMenuMobile(!menuMobile);
              if (!menuMobile && window.innerWidth <= 990)
                document.body.classList.add('fix');
              else document.body.classList.remove('fix');
            }}
          >
            <IconMenu classCss={`${menuMobile ? 'u-display-none' : ''}`} />
            <IconX classCss={`${!menuMobile ? 'u-display-none' : ''}`} />
          </div>

          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className="logo logo__mobile"
            onClick={(e) => {
              clickLogo(e);
            }}
          >
            <IconCapraboClubMenuMovile />
          </div>
        </div>
        <div className="idiomas-link">
          <div className="select-wrapper">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="hidden" htmlFor="idioma">
              {t('header.idioma')}
            </label>
            <select
              className="form-control"
              id="idioma"
              value={languaje}
              onChange={($event) => setLanguajeHadler($event.target.value)}
            >
              <option value="es">ES</option>
              <option value="ca">CA</option>

              {/* <option value="de">DE</option> */}
            </select>
          </div>
          <div className="icon icon-small">
            <IconChat />
          </div>
        </div>
        <IconLinkBlock
          text={t('header.contacto')}
          fromApp={`${t('caprabo_com')}`}
          url={`${process.env.REACT_APP_CLUB_CAPRABO}${languaje}/atencion-cliente/`}
        >
          <IconContacto />
        </IconLinkBlock>
        <IconLinkBlock
          text={t('header.tienda')}
          fromApp={`${t('caprabo_com')}`}
          url={`${process.env.REACT_APP_CLUB_CAPRABO}${languaje}/home/localizador-de-supermercados/`}
        >
          <IconTiendas />
        </IconLinkBlock>
        <IconLinkBlock
          text={t('header.chef-caprabo')}
          fromApp={`${t('chef_caprabo')}`}
          url={`${process.env.REACT_APP_CHEF_CAPRABO}${languaje}/home`}
        >
          <IconChef />
        </IconLinkBlock>
        <IconLinkBlock
          text={t('header.bienvenida-matrona')}
          // fromApp={`${t('matrona')}`}
          url={`${
            languaje === 'ca'
              ? process.env.REACT_APP_CAPRABO_MATRONA?.concat('cat')
              : process.env.REACT_APP_CAPRABO_MATRONA?.concat(languaje)
          }`}
        >
          <IconHeartMatrona />
        </IconLinkBlock>
        <BlockLinkSameTarget
          text={t('header.caprabo')}
          fromApp={`${t('caprabo_com')}`}
          url={`${process.env.REACT_APP_CLUB_CAPRABO}${languaje}/home`}
        />
        <BlockLink
          text={t('header.caprabo-casa')}
          fromApp={`${t('web_ecommerce')}`}
          title="Caprabo a casa"
          className="block-link__grey"
          url={`${process.env.REACT_APP_CAPRABO_CASA}`}
        />
        <BlockHello
          text={t('header.hola', { user: userName })}
          className="block-link__saludo"
        />
      </div>
      {miCuenta.length > 0 && (
        <div className="container">
          <nav className="bloque-nav">
            <div className="logo">
              <a
                /* eslint-disable-next-line no-script-url */
                href="javascript:void(0)"
                onClick={(e) => {
                  clickLogo(e);
                }}
              >
                <span className="hidden">Enlace a la home de Area-cliente</span>
                <IconCapraboClub />
              </a>
            </div>
            <div className={`main-menu ${menuMobile ? 'visible' : ''}`}>
              <ul className="main-menu__list">
                {ventajas &&
                  ventajas.map((acc: AccessType) => (
                    <MainmenuLink
                      text={acc.descripcion}
                      url={getUrl(acc)}
                      key={acc.descripcion}
                      className={`${isUrlActive(acc)}`}
                      openInNewWindow={acc.openInNewWindow}
                      setShowMiCuenta={() => {
                        setShowMiCuenta(false);
                        setMenuMobile(false);
                      }}
                    />
                  ))}

                <li
                  className={`main-menu__item main-menu__item--dropdown ${isUrlActiveMiCuenta()}`}
                >
                  {' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href=""
                    className="u-display-flex dropdown-link"
                    onKeyDown={() => null}
                    onClick={(e) => {
                      clickMiCuenta(e);
                    }}
                  >
                    <span id="dropdown-menu">{miCuentaText}</span>
                    <div className="icon icon-tiny">
                      <IconArrowDown classCss="icon icon-small" />
                    </div>
                  </a>
                  <ul
                    className={`dropdown-menu ${
                      showMiCuenta ? 'visible' : ''
                    } ${isClicked ? 'is-clicked' : ''}`}
                  >
                    <li className="dropdown-menu--item dropdown-menu--item-cerrar">
                      <a
                        href=""
                        className="u-display-flex u-font-bold"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setShowMiCuenta(false);
                        }}
                      >
                        <div className="icon icon-medium">
                          <IconArrowPrev />
                        </div>
                        <span className="u-margin-left">{miCuentaText}</span>
                      </a>
                    </li>
                    {miCuenta &&
                      miCuenta.map((acc: AccessType) => (
                        <DropdownLink
                          text={acc.descripcion}
                          upperLevelText={miCuentaText}
                          url={getUrl(acc)}
                          key={acc.url}
                          openInNewWindow={acc.openInNewWindow}
                          className={`${isUrlActive(acc)}`}
                          setShowMiCuenta={() => {
                            setShowMiCuenta(!showMiCuenta);
                            setMenuMobile(false);
                          }}
                          setIsClicked={setIsClicked}
                        />
                      ))}
                  </ul>
                </li>
                {solicitarTarjeta && (
                  <li className="m-mobile__item">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href=""
                      onClick={(e) =>
                        StorageHelper.deleteUserFromSessionAndRedirect(
                          access.solicitarTarjeta,
                          languaje,
                          APP_BASE_URL,
                          e,
                          '',
                        )
                      }
                      className="icon-link icon-link__oro"
                    >
                      <img src={access.solicitarTarjeta?.urlImagen} alt="" />
                      <span>{access.solicitarTarjeta?.descripcion}</span>
                    </a>
                  </li>
                )}
                <li className="m-mobile__item">
                  <div className="block-flex u-justify-content-space-between">
                    <BlockLinkBrand
                      text={t('header.caprabo')}
                      url={`${
                        process.env.REACT_APP_API_CAPRABO
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_CLUB_CAPRABO
                      }${dataApp.lang}/home/&fromApp=${t('caprabo_com')}`}
                    >
                      <IconHome />
                    </BlockLinkBrand>
                    <BlockLinkBrand
                      text={t('header.caprabo-casa')}
                      url={`${process.env.REACT_APP_CAPRABO_CASA?.replace(
                        'https://www2.',
                        'https://www.',
                      )}`}
                    >
                      <IconSuperonline />
                    </BlockLinkBrand>
                    <BlockLinkBrand
                      text={t('header.tienda')}
                      url={`${
                        process.env.REACT_APP_API_CAPRABO
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_CLUB_CAPRABO
                      }${
                        dataApp.lang
                      }/home/localizador-de-supermercados/&fromApp=${t(
                        'caprabo_com',
                      )}`}
                    >
                      <IconTiendas />
                    </BlockLinkBrand>
                  </div>
                </li>
                <li className="m-mobile__item">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="">{t('header.contacto')}</a>
                </li>
                <li className="m-mobile__item idiomas-link">
                  <div className="form-group select-wrapper">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label className="hidden" htmlFor="idioma-mobile">
                      {t('header.idioma')}
                    </label>
                    <div className="form-control-block">
                      <select
                        className="form-control"
                        id="idioma-mobile"
                        value={languaje}
                        onChange={($event) => {
                          $event.preventDefault();
                          $event.stopPropagation();
                          setMenuMobile(false);
                          setLanguajeHadler($event.target.value);
                        }}
                      >
                        <option value="es">Español(es)</option>
                        <option value="ca">Catalán(ca)</option>
                      </select>
                    </div>
                  </div>
                </li>
                <li className="m-mobile__item">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href=""
                    className="u-display-flex"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      StorageHelper.removeSessionVars();
                      setIsClicked(true);
                      // setShowMiCuenta(!showMiCuenta);
                      dataApp.closeSession();
                    }}
                  >
                    <IconSalir classCss="icon icon-medium" />

                    <span className="u-margin-left u-font-light">
                      {t('header.salir')}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            {solicitarTarjeta && (
              <>
                <div className="icon-link-block">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href=""
                    onClick={handleClick}
                    className="icon-link icon-link__oro"
                  >
                    <img src={access.solicitarTarjeta?.urlImagen} alt="" />
                    <span>{access.solicitarTarjeta?.descripcion}</span>
                  </a>
                </div>
                <ModalConfirmacion
                  isBig={false}
                  isSmall
                  textCentered
                  showModal={showError}
                  setShowModal={setShowError}
                  title=""
                  textHTMLContent={t(messageError)}
                  doAceptar={goToMisDatosAndOpenModal}
                  doClose={emptymethod}
                  showCancel={false}
                  acceptButtonTextKey={t('datos.accessdata.accept')}
                  hideXButton
                />
                <ModalConfirmacion
                  isBig={false}
                  isSmall
                  textCentered
                  showModal={showDniError}
                  setShowModal={setShowDniError}
                  title={t('nlr-vaya-algo-no-ha-ido-bien')}
                  textHTMLContent={getHTMLContent()}
                  doAceptar={() => null}
                  doClose={emptymethod}
                  showCancel={false}
                  acceptButtonTextKey={t('entendido')}
                  hideXButton
                />
              </>
            )}
          </nav>
        </div>
      )}
      {/* <Divider /> */}
    </header>
  );
};

export default HeaderCaprabo;
